import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Popconfirm, Radio, Card, Input, Select, Checkbox, DatePicker, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import AdminModal from "./AdminModal";
import axios from 'axios';
import dayjs from 'dayjs';
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const PermissionModal = (props) => {
    const [permission_list, set_permission_list] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const ref = useRef(0);
    useEffect(() => {
        axios
            .get('/permission_management/permission/list')
            .then((response) => {
                set_permission_list(response.data.data.map(map_item => {
                    return {
                        value: map_item.permission_id,
                        label: map_item.permission_name,
                    };
                }))
            })
    }, [])
    useEffect(() => {
        console.log(props.editcard);
    }, [props.editcard])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 30, left: 45 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 65, left: 25 }} >權限管理</Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>人員姓名</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入人員名稱'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} autoComplete='off' />
                    </Col>
                    <Col span={6}>人員帳號</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入人員帳號'} type='text' value={props.editcard.serial_name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, serial_name: e.target.value }))} autoComplete='off' />
                    </Col>
                    <Col span={6}>人員類別</Col>
                    <Col span={18}>
                        <Select
                            placeholder='請選擇人員類別'
                            value={props.editcard['position_type']}
                            style={{ width: '100%' }}
                            options={[{
                                value: '老師端',
                                label: '老師端'
                            }, {
                                value: '行政端',
                                label: '行政端'
                            }]}
                            onChange={
                                value => props.setEditCard(
                                    pre => ({
                                        ...pre,
                                        position_type: value
                                    }))}></Select>
                    </Col>
                    <Col span={6}>人員職位</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入人員職位'} type='text' value={props.editcard.position} name="position" onChange={e => props.setEditCard(pre => ({ ...pre, position: e.target.value }))} autoComplete='off' />
                    </Col>
                    <Col span={7}>人員權限管理</Col>
                    <Col span={24}>
                        <Checkbox.Group
                            style={{
                                width: '100%',
                            }}
                            value={props.editcard.role_permission && props.editcard.role_permission.map((item) => item.permission_id)}
                            onChange={checkedValues => {
                                let data_tmp = [];
                                checkedValues.map((item) => { data_tmp.push({ 'permission_id': item, "permission_level_id": 2 }) });
                                props.setEditCard(
                                    pre => ({
                                        ...pre,
                                        role_permission: data_tmp
                                    }))
                            }}
                        >
                            <Row>
                                {permission_list && permission_list.map((item, i) => {
                                    return (
                                        <Col span={12}>
                                            <Checkbox value={item['value']}>{item['label']}</Checkbox>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </Checkbox.Group>
                    </Col>
                    <Col span={9}>使用起始日</Col>
                    <Col span={15}>
                        <DatePicker style={{ width: '100%' }}
                            value={props.editcard.permission_time_start != null ? dayjs(props.editcard.permission_time_start, 'YYYY-MM-DD') : ''}
                            format={'YYYY-MM-DD'}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'permission_time_start': dateString,
                                    }
                                )
                            })}
                        />
                    </Col>
                    <Col span={9}>使用結束日</Col>
                    <Col span={15}>
                        <DatePicker style={{ width: '100%' }}
                            value={props.editcard.permission_time_end != null ? dayjs(props.editcard.permission_time_end, 'YYYY-MM-DD') : ''}
                            format={'YYYY-MM-DD'}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'permission_time_end': dateString,
                                    }
                                )
                            })}
                        />
                    </Col>
                </Row>
            </AdminModal >

        </>
    )

}
export default PermissionModal;